import { memo } from "react";
import { classNames } from "helpers";
import { formatDateParam } from "helpers/common";
import CalendarEvent from "../CalendarEvent/CalendarEvent";
import { DAYS_OF_WEEK } from "../../consts";
import { WeekGridProps } from "../../types";

const WeekGrid: React.FC<WeekGridProps> = (props) => {
  const { days, itemsByDate, selectedDate, onDayClick } = props;

  const todayKey = formatDateParam(new Date());

  return (
    <div className="grid grid-cols-7">
      {days.map((day, index) => {
        const key = formatDateParam(day)!;
        const items = itemsByDate.get(key) ?? [];
        const isToday = key === todayKey;

        const handleClick = () => onDayClick(day);

        return (
          <div
            key={key}
            onClick={handleClick}
            className={classNames(
              // `min-w-0`: bez toga dugi naslov razvuče stupac i mreža izađe izvan kartice.
              "min-w-0 overflow-hidden min-h-[420px] border-r border-slate-100 last:border-r-0 cursor-pointer transition-colors",
              selectedDate === key ? "bg-sky-50/70" : "hover:bg-slate-50/60"
            )}
          >
            <div className="flex items-center justify-center gap-2 py-2 border-b border-slate-200">
              <span className="text-xs font-medium text-gray-500">
                {DAYS_OF_WEEK[index]}
              </span>
              <span
                className={classNames(
                  "w-6 h-6 flex items-center justify-center rounded-full text-xs font-semibold",
                  isToday ? "bg-sky-600 text-white" : "text-gray-700"
                )}
              >
                {day.getDate()}
              </span>
            </div>

            <div className="p-1.5 space-y-1.5">
              {items.map((item, itemIndex) => (
                <CalendarEvent key={`${item.id}-${itemIndex}`} item={item} showChannels />
              ))}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default memo(WeekGrid);
